<template>
  <div class="step-counter" :class="themeClass">
    {{ text }}
  </div>
</template>

<script>
const THEMES = ['passed', 'disabled'];

export default {
  name: 'step-counter',
  props: {
    text: {
      type: String,
      required: false,
      default: '',
    },
    theme: {
      type: String,
      required: false,
      default: '',
      validator: function (theme) {
        return theme ? THEMES.includes(theme) : true
      }
    },
  },
  computed: {
    themeClass() {
      return this.theme ? `step-counter--${this.theme}` : '';
    },
  },
}
</script>

<style lang="scss" scoped>
.step-counter {
  @include text-props(14, 17, 700);

  $size: 32px;

  display: flex;
  align-items: center;
  justify-content: center;

  width: rem($size);
  height: rem($size);

  color: #fff;
  border-radius: rem(8);
  background-color: $bondi-blue;

  &--passed {
    color: $monte-carlo;
    background-color: $swans-down;
  }

  &--disabled {
    color: #969696;
    background-color: #CBCBCB;
  }
}
</style>
